module.exports = __webpack_public_path__ + "img/cerrar-duo.59942a3c.svg";